import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
`;

export const QueueNameWrapper = styled.span`
  font-size: 0.9rem;
  margin-left: 8px;
`;
